import { useMemo } from 'react';

import { BOOKMARK_TYPE, prepareBookmark } from 'src/data/bookmark';

import useCurrentUser from './useCurrentUser';

export const useProjectTypeBookmarks = () => {
  const currentUser = useCurrentUser();

  return useMemo(() => {
    if (!currentUser) {
      return [];
    }

    const bookmarks = currentUser.bookmarks || [];
    return bookmarks
      .filter((item) => item.type === BOOKMARK_TYPE.projectType)
      .map((bookmark) => prepareBookmark(bookmark));
  }, [currentUser]);
};
